import { computed } from 'vue';

import { propsFactory } from '@components/utils';

import type { ComputedRef, PropType } from 'vue';

export interface ITitleProps {
  title: string;
}
export interface IUseTitle {}

export interface IUseTitle {
  hasTitle: ComputedRef<boolean>;
}

export const makeTitleProps = propsFactory(
  {
    /**
     * Заголовок
     */
    title: {
      type: String as PropType<string>,
      default: ''
    }
  },
  'title'
);

export function useTitle(props: ITitleProps, slots: Record<string, unknown>): IUseTitle {
  const hasTitle = computed(() => {
    return !!props.title || !!slots.title;
  });

  return { hasTitle };
}
